var map = {
	"./": 37,
	"./Assets/Booking/booking-header.jpg": 90,
	"./Assets/Footer/banner.jpg": 91,
	"./Assets/Footer/map.jpg": 176,
	"./Assets/Footer/waze.svg": 92,
	"./Assets/Gallery/00.jpg": 51,
	"./Assets/Gallery/01.jpg": 52,
	"./Assets/Gallery/010.jpg": 130,
	"./Assets/Gallery/011.jpg": 131,
	"./Assets/Gallery/012.jpg": 132,
	"./Assets/Gallery/013.jpg": 133,
	"./Assets/Gallery/014.jpg": 134,
	"./Assets/Gallery/015.jpg": 135,
	"./Assets/Gallery/016.jpg": 57,
	"./Assets/Gallery/017.jpg": 58,
	"./Assets/Gallery/018.jpg": 59,
	"./Assets/Gallery/019.jpg": 136,
	"./Assets/Gallery/02.jpg": 53,
	"./Assets/Gallery/020.jpg": 137,
	"./Assets/Gallery/021.jpg": 138,
	"./Assets/Gallery/022.jpg": 139,
	"./Assets/Gallery/03.jpg": 54,
	"./Assets/Gallery/04.jpg": 140,
	"./Assets/Gallery/05.jpg": 141,
	"./Assets/Gallery/06.jpg": 142,
	"./Assets/Gallery/07.jpg": 143,
	"./Assets/Gallery/08.jpg": 144,
	"./Assets/Gallery/09.jpg": 145,
	"./Assets/General/arrow_down.svg": 93,
	"./Assets/General/close.svg": 177,
	"./Assets/General/doc.svg": 178,
	"./Assets/General/loading.gif": 78,
	"./Assets/General/logo-full.png": 179,
	"./Assets/General/pin.svg": 79,
	"./Assets/General/scroll-down-dark.png": 128,
	"./Assets/General/scroll-down.png": 129,
	"./Assets/General/v1.jpg": 87,
	"./Assets/General/v2.jpg": 88,
	"./Assets/Hotel/biosphere-certified.jpg": 82,
	"./Assets/Hotel/codigo-etico-omt.jpg": 83,
	"./Assets/Hotel/inguat-sello-q.jpg": 80,
	"./Assets/Hotel/siccs.jpg": 81,
	"./Assets/Navbar/Sidebar.jpg": 180,
	"./Assets/Opinions/pic01.jpg": 181,
	"./Assets/Opinions/pic02.jpg": 182,
	"./Assets/Opinions/pic03.jpg": 183,
	"./Assets/Rooms/bed.svg": 84,
	"./Assets/Rooms/calendar.svg": 86,
	"./Assets/Rooms/calendarW.svg": 71,
	"./Assets/Rooms/habitaciones/hab1-0.jpg": 94,
	"./Assets/Rooms/habitaciones/hab1-1.jpg": 95,
	"./Assets/Rooms/habitaciones/hab1-2.jpg": 96,
	"./Assets/Rooms/habitaciones/hab10-0.jpg": 184,
	"./Assets/Rooms/habitaciones/hab10-1.jpg": 185,
	"./Assets/Rooms/habitaciones/hab2-0.jpg": 97,
	"./Assets/Rooms/habitaciones/hab2-1.jpg": 98,
	"./Assets/Rooms/habitaciones/hab2-2.jpg": 99,
	"./Assets/Rooms/habitaciones/hab3-0.jpg": 100,
	"./Assets/Rooms/habitaciones/hab3-1.jpg": 101,
	"./Assets/Rooms/habitaciones/hab3-2.jpg": 102,
	"./Assets/Rooms/habitaciones/hab4-0.jpg": 103,
	"./Assets/Rooms/habitaciones/hab4-1.jpg": 104,
	"./Assets/Rooms/habitaciones/hab4-2.jpg": 105,
	"./Assets/Rooms/habitaciones/hab5-0.jpg": 106,
	"./Assets/Rooms/habitaciones/hab5-1.jpg": 107,
	"./Assets/Rooms/habitaciones/hab5-2.jpg": 108,
	"./Assets/Rooms/habitaciones/hab6-0.jpg": 109,
	"./Assets/Rooms/habitaciones/hab6-1.jpg": 110,
	"./Assets/Rooms/habitaciones/hab6-2.jpg": 111,
	"./Assets/Rooms/habitaciones/hab7-0.jpg": 112,
	"./Assets/Rooms/habitaciones/hab7-1.jpg": 113,
	"./Assets/Rooms/habitaciones/hab7-2.jpg": 114,
	"./Assets/Rooms/habitaciones/hab8-0.jpg": 115,
	"./Assets/Rooms/habitaciones/hab8-1.jpg": 116,
	"./Assets/Rooms/habitaciones/hab8-2.jpg": 117,
	"./Assets/Rooms/habitaciones/hab9-0.jpg": 118,
	"./Assets/Rooms/habitaciones/hab9-1.jpg": 119,
	"./Assets/Rooms/habitaciones/hab9-2.jpg": 120,
	"./Assets/Rooms/photo@2x.png": 85,
	"./Assets/Services/capacitaciones.jpg": 186,
	"./Assets/Services/xela.jpg": 187,
	"./Components/App/App": 42,
	"./Components/App/App.tsx": 42,
	"./Components/Carousel/Carousel": 20,
	"./Components/Carousel/Carousel.module.css": 69,
	"./Components/Carousel/Carousel.tsx": 20,
	"./Components/CloseButton/CloseButton": 12,
	"./Components/CloseButton/CloseButton.module.css": 89,
	"./Components/CloseButton/CloseButton.tsx": 12,
	"./Components/DatePicker/DatePicker": 31,
	"./Components/DatePicker/DatePicker.module.css": 10,
	"./Components/DatePicker/DatePicker.tsx": 31,
	"./Components/Footer/Footer": 62,
	"./Components/Footer/Footer.module.css": 7,
	"./Components/Footer/Footer.tsx": 62,
	"./Components/Input/Input": 45,
	"./Components/Input/Input.module.css": 23,
	"./Components/Input/Input.tsx": 45,
	"./Components/Location/Location": 32,
	"./Components/Location/Location.module.css": 29,
	"./Components/Location/Location.tsx": 32,
	"./Components/Navbar/Navbar": 63,
	"./Components/Navbar/Navbar.module.css": 8,
	"./Components/Navbar/Navbar.tsx": 63,
	"./Components/Scroll/Scroll": 55,
	"./Components/Scroll/Scroll.module.css": 70,
	"./Components/Scroll/Scroll.tsx": 55,
	"./Components/showBook/ShowBook": 26,
	"./Components/showBook/ShowBook.module.css": 14,
	"./Components/showBook/ShowBook.tsx": 26,
	"./Context/MainContext": 2,
	"./Context/MainContext.ts": 2,
	"./Fonts/DidactGothic-Regular.ttf": 188,
	"./Fonts/LICENSE.txt": 189,
	"./Fonts/NotoSerifTC-Bold.woff2": 190,
	"./Fonts/NotoSerifTC-Regular.woff2": 191,
	"./Fonts/Roboto-Condensed.ttf": 192,
	"./Fonts/RobotoCondensed-Bold.ttf": 193,
	"./Fonts/RobotoCondensed-BoldItalic.ttf": 194,
	"./Fonts/RobotoCondensed-Italic.ttf": 195,
	"./Fonts/RobotoCondensed-Light.ttf": 196,
	"./Fonts/RobotoCondensed-LightItalic.ttf": 197,
	"./Fonts/RobotoCondensed-Regular.ttf": 198,
	"./Hooks/Hooks": 25,
	"./Hooks/Hooks.ts": 25,
	"./Icons/Icons.css": 125,
	"./Icons/LineIcons.woff2": 199,
	"./Lang/Strings": 19,
	"./Lang/Strings.json": 19,
	"./LocalGlobals/Locals": 44,
	"./LocalGlobals/Locals.ts": 44,
	"./LocalGlobals/global.d": 146,
	"./LocalGlobals/global.d.ts": 146,
	"./Pages/Gallery/Gallery": 64,
	"./Pages/Gallery/Gallery.module.css": 17,
	"./Pages/Gallery/Gallery.tsx": 64,
	"./Pages/Home/Home": 50,
	"./Pages/Home/Home.module.css": 21,
	"./Pages/Home/Home.tsx": 50,
	"./Pages/Hotel/Hotel": 56,
	"./Pages/Hotel/Hotel.module.css": 5,
	"./Pages/Hotel/Hotel.tsx": 56,
	"./Pages/Index/Index": 49,
	"./Pages/Index/Index.tsx": 49,
	"./Pages/Policies/Policies": 66,
	"./Pages/Policies/Policies.module.css": 27,
	"./Pages/Policies/Policies.tsx": 66,
	"./Pages/Reservations/Reservations": 43,
	"./Pages/Reservations/Reservations.module.css": 3,
	"./Pages/Reservations/Reservations.tsx": 43,
	"./Pages/Rooms/Rooms": 67,
	"./Pages/Rooms/Rooms.module.css": 6,
	"./Pages/Rooms/Rooms.tsx": 67,
	"./Pages/Services/Services.module.css": 1,
	"./Pages/Services/ServicesContact": 36,
	"./Pages/Services/ServicesContact.tsx": 36,
	"./Pages/Services/ServicesIntro": 60,
	"./Pages/Services/ServicesIntro.tsx": 60,
	"./Pages/Services/ServicesSliders": 61,
	"./Pages/Services/ServicesSliders.tsx": 61,
	"./Utils/CountryCodes": 35,
	"./Utils/CountryCodes.json": 35,
	"./Utils/Fx": 28,
	"./Utils/Fx.ts": 28,
	"./Utils/Querys": 46,
	"./Utils/Querys.ts": 46,
	"./Utils/Storage": 65,
	"./Utils/Storage.ts": 65,
	"./Utils/Tools": 22,
	"./Utils/Tools.ts": 22,
	"./index": 37,
	"./index.css": 147,
	"./index.tsx": 37,
	"./keys/firebase": 33,
	"./keys/firebase.ts": 33,
	"./keys/keys": 48,
	"./keys/keys.json": 48,
	"./react-app-env.d": 148,
	"./react-app-env.d.ts": 148,
	"./serviceWorker": 68,
	"./serviceWorker.ts": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 175;